var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6860",
    "data-name": "Group 6860",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16.792,
    height: 16.837,
    viewBox: "0 0 16.792 16.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3201",
    "data-name": "Rectangle 3201",
    width: 16.792,
    height: 16.837,
    fill: "#ed4d53"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6860-2",
    "data-name": "Group 6860",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3221",
    "data-name": "Path 3221",
    d: "M14.272,49.736v.279q0,4.84,0,9.68a2.6,2.6,0,0,1-.591,1.75,2.471,2.471,0,0,1-1.967.908c-2.216,0-4.433.009-6.649,0a2.5,2.5,0,0,1-2.513-2.089,3.222,3.222,0,0,1-.039-.608q0-4.82,0-9.64v-.277c-.223,0-.424,0-.625,0-.38,0-.761.009-1.14-.014A.8.8,0,0,1,0,48.982a.826.826,0,0,1,.583-.894,1.261,1.261,0,0,1,.349-.04q7.456,0,14.912,0a.853.853,0,0,1,.845.463.809.809,0,0,1-.065.875.834.834,0,0,1-.73.353H14.272M5.874,55.2c0,.683,0,1.366,0,2.049a.843.843,0,0,0,.829.889.826.826,0,0,0,.843-.869c.008-1.379.011-2.759-.006-4.138a1.1,1.1,0,0,0-.2-.575.779.779,0,0,0-.9-.246.833.833,0,0,0-.56.8c-.005.7,0,1.392,0,2.089m5.038,0c0-.683,0-1.366,0-2.049a.842.842,0,0,0-.829-.889.826.826,0,0,0-.844.869c-.007,1.379-.01,2.759.006,4.138a1.086,1.086,0,0,0,.19.561.786.786,0,0,0,.9.268.837.837,0,0,0,.578-.808c.006-.7,0-1.393,0-2.089",
    transform: "translate(0 -45.52)",
    fill: "#ed4d53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3222",
    "data-name": "Path 3222",
    d: "M114.175,1.683c-.583,0-1.166.014-1.749,0a.8.8,0,0,1-.734-.637.814.814,0,0,1,.357-.889,1.015,1.015,0,0,1,.479-.142q1.661-.018,3.322,0a.826.826,0,0,1,.86.833.831.831,0,0,1-.864.85c-.557.01-1.114,0-1.671,0V1.683",
    transform: "translate(-105.799 0)",
    fill: "#ed4d53"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrash);
export default __webpack_public_path__ + "static/media/red-trash.12426a89b13a7d37f45dec800c35f602.svg";
export { ForwardRef as ReactComponent };